export default __webpack_public_path__ + "static/media/uems-ventures-logo.52beb2ca.png";